import HeroImg2 from "../Components/Layouts/HeroImg";
import { useCart } from "../context/CartContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaTrash } from "react-icons/fa";
import "./Cart.scss";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";

export default function CartPage() {
  const { cart, error, fetchCart, removeFromCart, clearCart } = useCart();
  const [loading, setLoading] = useState(true);
  const [medicine, setMedicine] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { user, authloading } = useAuth();

  const viewDetail = async (id, { setLoading, showToast }) => {
    try {
      setLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/medicines/${id}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      const data = await res.json();
      setMedicine(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showToast("Failed to fetch medicine details", {
        type: "error",
      });
    }
  };

  useEffect(() => {
    // if (authloading) return;
    fetchCart({ setLoading, showToast: (msg, opts) => toast(msg, opts) });
  }, [authloading]);

  const totalPrice = cart.reduce(
    (total, item) => total + item.medicine.price * item.quantity,
    0
  );

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <>
      <HeroImg2 heading="Cart" text="Home / Cart" />

      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : cart.length === 0 ? (
        <div className="empty">
          <img src="/emptycart.png" alt="empty cart" />
          <h3>Your cart is empty!!</h3>
          <button className="buy" onClick={() => navigate("/")}>
            Continue Shopping
          </button>
          {!user && (
            <div>
              {" "}
              <h3>Have an account?</h3>
              <p style={{ marginTop: "10px" }}>
                <a href="/login">Login</a> to check out faster!!
              </p>
            </div>
          )}
        </div>
      ) : (
        <>
          <div className="cart-grid">
            {cart.map((item) => (
              <div className="cart-card" key={item.medicine._id}>
                <img
                  src={`data:image/png;base64,${item.medicine.image}`}
                  alt={item.medicine.name}
                />
                <h2>
                  {item.medicine.name} - {item.quantity}
                </h2>
                <p>Price: ₹{item.medicine.price}</p>
                <p>Total: ₹{item.medicine.price * item.quantity}</p>
                <span>
                  {item.medicine.stock < item.quantity ? (
                    <p style={{ color: "Red" }}>Out of Stock</p>
                  ) : (
                    <p style={{ color: "Green" }}>In Stock</p>
                  )}
                </span>

                <div className="cart-button">
                  <span
                    onClick={() =>
                      removeFromCart(item.medicine._id, {
                        setLoading,
                        showToast: (msg, opts) => toast(msg, opts),
                      })
                    }
                    className="remove"
                  >
                    <FaTrash style={{ color: "#ffffff" }} />
                  </span>
                  <span
                    onClick={() => {
                      setIsModalOpen(true);
                      viewDetail(item.medicine._id, {
                        setLoading,
                        showToast: (msg, opts) => toast(msg, opts),
                      });
                    }}
                    className="view"
                  >
                    <FaEye style={{ color: "#ffffff" }} />
                  </span>
                </div>
              </div>
            ))}
          </div>

          {isModalOpen && medicine && (
            <div
              className="modal-overlay active"
              onClick={() => setIsModalOpen(false)}
            >
              <div
                className="service-modal active"
                onClick={(e) => e.stopPropagation()}
              >
                {loading ? (
                  <div className="loader"> </div>
                ) : (
                  <div className="modal-content">
                    <span
                      className="close-modal"
                      onClick={() => setIsModalOpen(false)}
                    >
                      &times;
                    </span>
                    <img
                      src={`data:image/png;base64,${medicine.image}`}
                      alt={medicine.name}
                    />
                    <h2>{medicine.name}</h2>
                    <p>
                      <strong>Category:</strong> {medicine.category}
                    </p>
                    <p>
                      <strong>Description:</strong> {medicine.description}
                    </p>
                    <p className="price">₹{medicine.price}</p>

                    <div className="reviews">
                      <h3>Reviews</h3>
                      <ul className="reviews">
                        {medicine.reviews?.length > 0 ? (
                          medicine.reviews.map((review) => (
                            <li key={review._id}>
                              <div className="user-info">
                                <strong>{review.user.name}</strong>
                                <p>
                                  {new Date(
                                    review.createdAt
                                  ).toLocaleDateString()}
                                </p>
                              </div>
                              <div className="rating-info">
                                <div className="star-rating">
                                  {[1, 2, 3, 4, 5].map((star) => (
                                    <span key={star}>
                                      {star <= review.rating ? "⭐" : "☆"}
                                    </span>
                                  ))}
                                </div>
                                {review.comment}
                              </div>
                            </li>
                          ))
                        ) : (
                          <p>No reviews yet.</p>
                        )}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {cart.length > 0 && (
            <div>
              <div className="total-price">
                <h2>Total Price: ₹{totalPrice}</h2>
                <h2>Total Items: {cart.length}</h2>
              </div>
              <div className="cart-button">
                <span
                  className="clear"
                  onClick={() =>
                    clearCart({
                      setLoading,
                      showToast: (msg, opts) => toast(msg, opts),
                    })
                  }
                >
                  Clear Cart
                </span>
                <span
                  onClick={() =>
                    navigate("/cart/checkout", { state: { cart } })
                  }
                  className="buy"
                >
                  Buy Now
                </span>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
